/**
 * Compares referralEhrId between two events
 * @param ehrEvent First event to compare
 * @param currentEhrEvent Second event to compare
 * @returns True if events have different referralEhrId, false otherwise
 */
export const shouldSetNewEhrEvent = (ehrEvent: any, currentEhrEvent: any): boolean => {
  const ehrEventReferral = ehrEvent?.payload?.referral || ehrEvent?.payload;
  const currentEhrEventReferral = currentEhrEvent?.payload?.referral || currentEhrEvent?.payload;

  const ehrEventReferralId = ehrEventReferral?.referralId?.toString();
  const currentEhrEventReferralId = currentEhrEventReferral?.referralId?.toString();

  if (ehrEventReferralId === undefined) {
    return true;
  }

  return ehrEventReferralId !== currentEhrEventReferralId;
};
